import PropTypes from 'prop-types';
import React from 'react';

import { LocaleService, ContentZonesService } from '@sm360/widget-commons-core-services';

import 'vdp-used/components/PhotosAndBodyAndCertifiedSection/Certified/Certified.scss';

const Certified = ({ certifiedUrl }) => {
    const certifiedLink = certifiedUrl !== '' && (
        <a href={this.props.certifiedUrl} className="sr-link" title={LocaleService.t('VDP_USED.CERTIFIED.MORE_LINK')}>
            {LocaleService.t('VDP_USED.CERTIFIED.MORE_LINK')}
        </a>
    );
    const certifiedTextCZ = ContentZonesService.getContentZone('widget.vdp.used', 'widget.vdp.used.certified.text');
    const certifiedImageCZ = ContentZonesService.getContentZone(
        'widget.vdp.used.similar.cars',
        'widget.vdp.used.similar.cars.certified.img'
    );

    const certifiedImage =
        certifiedImageCZ && certifiedImageCZ.getValue() ? (
            <div className="certified-logo">
                <img className="custom-certified-logo" src={certifiedImageCZ.getValue()} alt="Certified" />
            </div>
        ) : (
            <div className="certified-logo">
                <icon className="icon-certified-badge" />
                <p className="is-light">{LocaleService.t('VDP_USED.CERTIFIED.BADGE_TITLE')}</p>
            </div>
        );

    return (
        <div className="showroom-vdp-used-certified-zone">
            {certifiedImage}
            <div className="certified-list">
                <div className="certified-title">{LocaleService.t('VDP_USED.CERTIFIED.TITLE')}</div>
                <p className="certified-text is-light">
                    {(certifiedTextCZ && certifiedTextCZ.getValue()) ||
                        LocaleService.t('VDP_USED.CERTIFIED.DESCRIPTION')}
                </p>
                {certifiedLink}
            </div>
        </div>
    );
};

Certified.propTypes = {
    certifiedUrl: PropTypes.string.isRequired,
};

Certified.displayName = 'Certified';

export default Certified;
